import {
	BNavbar,
	BNavbarBrand,
	BNavbarNav,
	BNavItem,
	BForm,
	BFormGroup,
	BFormInput,
	BFormInvalidFeedback,
	BFormText,
	BFormCheckbox,
	BFormTextarea,
	BFormSelect,
	BFormSelectOption,
	BFormTags,
	BInputGroup,
	BInputGroupAppend,
	BButton,
	BBadge,
	BModal,
	BAvatar,
	BPopover,
	BContainer,
	BCol,
	BRow,
	BSkeleton,
	BOverlay,
	BSpinner,
	BFormTag,
	BTable,
	BTableSimple,
	BThead,
	BTr,
	BTh,
	BTbody,
	BTd,
	BTfoot,
	BDropdown,
	BPagination,
} from 'bootstrap-vue-next';

export default function register(app) {
	// Nav
	app.component('b-navbar', BNavbar);
	app.component('b-navbar-brand', BNavbarBrand);
	app.component('b-navbar-nav', BNavbarNav);
	app.component('b-nav-item', BNavItem);

	// Form
	app.component('b-form', BForm);
	app.component('b-form-input', BFormInput);
	app.component('b-form-group', BFormGroup);
	app.component('b-form-invalid-feedback', BFormInvalidFeedback);
	app.component('b-form-text', BFormText);
	app.component('b-form-checkbox', BFormCheckbox);
	app.component('b-form-textarea', BFormTextarea);
	app.component('b-form-select', BFormSelect);
	app.component('b-form-select-option', BFormSelectOption);
	app.component('b-form-tags', BFormTags);
	app.component('b-form-tag', BFormTag);

	// Input group
	app.component('b-input-group', BInputGroup);
	app.component('b-input-group-append', BInputGroupAppend);

	// Grid
	app.component('b-container', BContainer);
	app.component('b-col', BCol);
	app.component('b-row', BRow);

	// Others
	app.component('b-button', BButton);
	app.component('b-modal', BModal);
	app.component('b-badge', BBadge);
	app.component('b-avatar', BAvatar);
	app.component('b-popover', BPopover);
	app.component('b-skeleton', BSkeleton);
	app.component('b-overlay', BOverlay);
	app.component('b-table', BTable);
	app.component('b-spinner', BSpinner);
	app.component('b-dropdown', BDropdown);

	// Tables
	app.component('b-table-simple', BTableSimple);
	app.component('b-thead', BThead);
	app.component('b-tbody', BTbody);
	app.component('b-tr', BTr);
	app.component('b-th', BTh);
	app.component('b-td', BTd);
	app.component('b-tfoot', BTfoot);
	app.component('b-pagination', BPagination);
}
